<template>
  <div class="about">
    <h1>{{title}}</h1>
    <ul>
      <li v-for="(item, index) in list"
      :key="item.id"
    :id="index"
    :class="item.done ? 'li' : null"
    >{{index+1}}、{{item.value}}</li>
    </ul>
    <button  @click.prevent="addList">新增</button>
  </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'
export default {
  data () {
    return {
      title: 'vuextest',
      todos: []
    }
  },
  computed: {
    ...mapState(['list'])
  },
  methods: {
    ...mapMutations([
      'ADD_LIST'
    ]),
    addList () {
      this.ADD_LIST({
        value: this.todos.length + 1,
        done: true
      })
    }
    
  }
}
</script>
<style>
  .li{
    color: red;
    list-style: none
  }
</style>
